export default __webpack_public_path__ + "static/media/icon-info.a39dbcb1.svg";